import {
  differenceInCalendarDays,
  format as formatFn,
  isValid,
  parseISO,
  subDays,
  startOfDay,
} from 'date-fns';

import en from 'date-fns/locale/en-GB';
import de from 'date-fns/locale/de';

import { getLocaleId } from '../../utils/languageTools';

const getLocale = () => {
  const { language } = window._hopsServerData || {};

  return language === 'de' ? de : en;
};

const dateFormats = {
  short: {
    de: 'do MMM yyyy',
    en: 'd MMM yyyy',
  },
};

export const formatDate = (date, format = 'short') => {
  const locale = getLocale();
  const localeId = getLocaleId();

  return formatFn(parseISO(date), dateFormats[format][localeId], { locale });
};

export const getDateString = (date) => formatFn(date, 'yyyy-MM-dd');

export const getDatesFromDaysAgo = ({ date = new Date(), days } = {}) => {
  const toDate = startOfDay(date);
  const fromDate = startOfDay(subDays(toDate, days));

  return { toDate, fromDate };
};

export const getCurrentPeriod = (daysCount) => {
  return getDatesFromDaysAgo({ days: daysCount - 1 });
};

export const getPreviousPeriod = ({ fromDate, toDate }) => {
  const previousPeriodToDate = subDays(fromDate, 1);

  return getDatesFromDaysAgo({
    date: previousPeriodToDate,
    days: differenceInCalendarDays(toDate, fromDate),
  });
};

export const calculatePeriods = ({ fromDate, toDate }) => {
  if (!fromDate || !toDate) {
    throw new Error('You must provide fromDate and toDate');
  }

  if (!isValid(fromDate)) {
    throw new Error('fromDate is not a valid Date');
  }

  if (!isValid(toDate)) {
    throw new Error('toDate is not a valid Date');
  }

  const currentPeriod =
    toDate < fromDate
      ? { fromDate: toDate, toDate: fromDate }
      : { fromDate, toDate };

  const previousPeriod = getPreviousPeriod(currentPeriod);

  return {
    fromDate: currentPeriod.fromDate,
    toDate: currentPeriod.toDate,
    stringDates: {
      from: getDateString(currentPeriod.fromDate),
      to: getDateString(currentPeriod.toDate),
      previousFrom: getDateString(previousPeriod.fromDate),
      previousTo: getDateString(previousPeriod.toDate),
    },
  };
};
